import axios from "axios";
import { convertSortDir } from "../utils";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const getOrders = async (q, filter_params, page, page_size, sort_by, sort_dir) => {

    let params = filter_params
    params['page'] = page
    params['page_size'] = page_size
    params['q'] = q
    params['sort_by'] = sort_by
    params['sort_dir'] = convertSortDir(sort_dir)

    const res = await axios.get(BACKEND_URL+'/orders', {
        params,
        withCredentials: true
    });
    return res;
}

export const createOrder = async (createObj) => {
    createObj  = Object.fromEntries(Object.entries(createObj).filter(([_, v]) => v !== undefined));
    const res = await axios.post(BACKEND_URL+'/orders',
    createObj,
    {
        withCredentials: true,
        successMessage: "Order ได้ถูกสร้างแล้ว"
    });
    return res;
}

export const updateOrder = async (id, updateObj) => {
    const res = await axios.put(BACKEND_URL+`/orders/${id}`,
    updateObj,
    {
        withCredentials: true,
        successMessage: "Order ได้ถูกแก้ไขแล้ว"
    });
    return res;
}

export const deleteOrder = async (id) => {
    const res = await axios.delete(BACKEND_URL+`/orders/${id}`,
    {
        withCredentials: true,
        successMessage: "Order ได้ถูกลบแล้ว"
    });
    return res;
}
